export const WaitListLink = 'https://docs.google.com/forms/d/1h4YFa3FaL-LcYKTDb0RQku6664lr7U-red3_TFpXM30/edit';
